import type { Location } from 'react-router';

const buildFromLocation = (location: Location) => {
    return `${location.pathname}${location.search}${location.hash}`;
};

export default buildFromLocation;
